import injector from 'vue-inject'
import axios from 'axios'
import moment from 'moment'
import * as types from '../../constants/types'
import * as specifications from '../../constants/specifications'
import { filterConfigs } from '../../constants/filter-configs'

injector.constant('themeColor', 'green')
injector.constant('axios', axios)
injector.constant('moment', moment)

injector.constant('apiStateType', types.apiStateType)
injector.constant('diningPreferenceType', types.diningPreferenceType)
injector.constant('receiptCarrierType', types.receiptCarrierType)
injector.constant('paymentMethodType', types.paymentMethodType)
injector.constant('orderStatusType', types.orderStatusType)
injector.constant('userSignInStatusType', types.userSignInStatusType)
injector.constant('questionType', types.questionType)
injector.constant('permissionType', types.permissionType)
injector.constant('imageResolutions', specifications.imageResolutions)
injector.constant('filterConfigs', filterConfigs)

injector.constant('baseUrl', process.env.NODE_ENV === 'local' ? window.location.origin : process.env.VUE_APP_URLS_BASE)
injector.constant('apiUrl', process.env.NODE_ENV === 'local' ? `http://${window.location.hostname}:8080` : process.env.VUE_APP_URLS_API)
